/***********************************************************************************************************************
 * Responsibility - Handles the data fetching and functionality for the contacts page and the production presets page.
 * *******************************************************************************************************************
 *
 * @format */

import {handleRollManMixValidation} from '../../../utilities/roll_min_max_validator';
import {MAXIMUM_ROLL_DIAMETER} from 'frontier-constants';
import {parseEntityError} from 'frontier-form';
import update from 'immutability-helper';
import SuperAgent from 'superagent';
import dot from 'dot-object';
import React from 'react';

export default function withAccountDetailsHandler(ComponentContainer) {
    return class extends React.Component {
        constructor(props) {
            super(props);
            this.timeout = null;
            this.state = {
                user: {},
                formData: {
                    is_default_blind_shipping: '',
                    is_fewest_possible_rolls: '',
                    is_paper_packing_list: '',
                    is_using_paper_backing: '',
                    roll_diameter_max: '',
                    shipping_email: '',
                    channel_other: '',
                    billing_email: '',
                    roll_qty_max: '',
                    reason_other: '',
                    proof_email: '',
                    channel_id: '',
                    first_name: '',
                    last_name: '',
                    reason_id: '',
                    full_name: '',
                    username: '',
                    company: '',
                    phone: '',
                    email: ''
                },
                formDataPassword: {
                    isPasswordValid: false,
                    currentPassword: '',
                    showToast: false,
                    newPassword: ''
                },
                accountDataError: false,
                savingPassword: false,
                passwordError: false,
                savingData: false,
                loading: true
            };
        }

        componentDidMount() {
            SuperAgent.get('/account/users/account-details')
                .set('accept', 'application/json')
                .end((err, response) => {
                    const {user} = response.body;
                    const {company_entity} = user;

                    this.setState({
                        loading: false,
                        user: user,
                        formData: {
                            is_default_blind_shipping: company_entity.is_default_blind_shipping,
                            is_fewest_possible_rolls: company_entity.is_fewest_possible_rolls,
                            is_paper_packing_list: company_entity.is_paper_packing_list,
                            is_using_paper_backing: company_entity.is_using_paper_backing,
                            roll_diameter_max: company_entity.roll_diameter_max ?? '',
                            full_name: user.first_name + ' ' + user.last_name,
                            roll_qty_max: company_entity.roll_qty_max ?? '',
                            channel_other: company_entity.channel_other,
                            reason_other: company_entity.reason_other,
                            channel_id: company_entity.channel_id,
                            reason_id: company_entity.reason_id,
                            shipping_email: user.shipping_email,
                            billing_email: user.billing_email,
                            proof_email: user.proof_email,
                            company: company_entity.name,
                            username: user.username,
                            email: user.username,
                            phone: user.phone
                        }
                    });
                });
        }

        handleDebounce = (callback, timeoutInSeconds = 1000) => {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
                // Your onchange event handler code here
                callback();
            }, timeoutInSeconds);
        };

        handleChange = updateTarget => {
            this.setState(update(this.state, updateTarget));
            // do not call auto-update for password changes
            if (!!updateTarget['formDataPassword']) return;

            this.setState({savingData: true, accountDataError: false});

            this.handleDebounce(() => {
                this.handleSaveAccountData();
            });
        };

        handleSaveAccountData = () => {
            this.setState({savingData: true, accountDataError: false});
            const {formData} = this.state;

            SuperAgent.post('/account/users/account-details/accountDetails')
                .set('accept', 'application/json')
                .send({
                    shipping_email: formData.shipping_email,
                    billing_email: formData.billing_email,
                    proof_email: formData.proof_email,
                    username: formData.username,
                    email: formData.username,
                    name: formData.full_name,
                    phone: formData.phone,
                    company_entity: {
                        is_default_blind_shipping: formData.is_default_blind_shipping,
                        is_fewest_possible_rolls: formData.is_fewest_possible_rolls,
                        is_paper_packing_list: formData.is_paper_packing_list,
                        is_using_paper_backing: formData.is_using_paper_backing,
                        channel_other: formData.channel_other,
                        reason_other: formData.reason_other,
                        channel_id: formData.channel_id,
                        reason_id: formData.reason_id,
                        name: formData.company,
                        roll_max:
                            parseInt(formData.roll_qty_max) > 0
                                ? formData.roll_qty_max
                                : formData.roll_diameter_max
                    }
                })
                .end((err, response) => {
                    if (err || !response.body) {
                        this.setState({
                            savingData: false,
                            accountDataError: parseEntityError(response.body)
                        });
                    } else {
                        this.setState({savingData: false, accountDataError: false});
                    }
                });
        };

        handleRollChange = (dotPath, value) => {
            value = value.replace(/[^0-9.]/g, '');
            value = parseFloat(value);

            if (isNaN(value)) {
                value = '';
            }

            if (dotPath.indexOf('roll_diameter_max') > -1) {
                // if (value > MAXIMUM_ROLL_DIAMETER) {
                //     value = MAXIMUM_ROLL_DIAMETER;
                // }

                const validationField = dotPath.split('.').pop();
                const validation = handleRollManMixValidation(parseInt(value), validationField);

                if (validation.error) {
                    this.setState({
                        accountDataError: {
                            [validationField]: {[validationField]: validation.error},
                            message: validation.error
                        }
                    });
                    return;
                }
            }
            const target = {};
            target[dotPath] = {$set: value};
            const state = dot.object(target);
            this.handleChange(state);
        };

        handleToggleToast = () => {
            this.setState({
                formDataPassword: {
                    ...this.state.formDataPassword,
                    showToast: true
                }
            });

            setTimeout(() => {
                this.setState({
                    formDataPassword: {
                        ...this.state.formDataPassword,
                        showToast: false
                    }
                });
            }, 3000);
        };

        handleCheckPasswordValidation = isPasswordValid => {
            this.setState({
                formDataPassword: {
                    ...this.state.formDataPassword,
                    isPasswordValid
                }
            });
        };

        handleSavePassword = () => {
            this.setState({savingPassword: true, passwordError: false});
            const {formDataPassword} = this.state;
            SuperAgent.post('/account/users/account-details/password')
                .set('accept', 'application/json')
                .send({
                    current_password: formDataPassword.currentPassword,
                    password: formDataPassword.newPassword,
                    id: this.state.user.id
                })
                .end((err, response) => {
                    if (err || !response.body) {
                        const errMessage = parseEntityError(response.body)?.message;
                        this.setState({
                            formDataPassword: {newPassword: '', currentPassword: ''},
                            passwordError: {
                                current_password: {current_password: errMessage},
                                message: errMessage
                            },
                            savingPassword: false
                        });
                    } else {
                        this.setState({
                            formDataPassword: {newPassword: '', currentPassword: ''},
                            savingPassword: false,
                            passwordError: false
                        });

                        this.handleToggleToast();
                    }
                });
        };

        render() {
            const props = {...this.props};

            props.handleCheckPasswordValidation = this.handleCheckPasswordValidation;
            props.onDeauthorizeGoogle = this.handleDeauthorizeGoogle;
            props.onSaveAccountData = this.handleSaveAccountData;
            props.onSavePassword = this.handleSavePassword;
            props.handleRollChange = this.handleRollChange;
            props.onChange = this.handleChange;

            return <ComponentContainer {...props} {...this.state} />;
        }
    };
}
